import { REFDOC_ARTIFACT, URLAPP, webApiEndpoints } from "../config";
import {
    ApidocType,
    MenusRolProps,
    CredentialType,
    NavItemDataProps,
    PaginatorProps,
    RepositoryApiSubTypes,
    RepositoryType,
    ResourceType,
    ResourceVersionType,
    SwaggerApiType,
    UserRolType,
    PageHeaderProps,
    ResourceVersionArtifactType,
    ArtifactFormProp,
    CredentialJiraType,
    PinnedDashboard
} from "../types"
import { mapper } from "./mapper.helper";

const regexp_version = /^[0-9]{0,3}(\.[0-9]{1,3}){0,2}$/;

const hideFirstCharacters = (data = "", showingSize = 4, replaceCharacter = "*") => Array.from(data).map((char, index) => showingSize > index ? char : replaceCharacter).join("")

const hideEmail = (email = "") => {
    let emailFragments = email.split('@')
    let domainData = emailFragments[1]?.split('.')
    let domain = domainData?.shift()
    let hiddenAddress = hideFirstCharacters(emailFragments[0], 5)
    let hiddenDomain = hideFirstCharacters(domain, 2)
    return `${hiddenAddress}@${hiddenDomain ?? ''}.${domainData?.join('.') ?? ''}`
}

const hideCharacters = (data = "", hidenSize = data.length - 4, replaceCharacter = "*") => {
    let size = hidenSize > 0 ? hidenSize : (data.length + hidenSize)
    return Array.from(data).map((char, index) => size > index ? replaceCharacter : char).join("")
}

const generateTicketsMenu = (ticketsCred: CredentialJiraType[], menu: NavItemDataProps) => {
    let counter = 500;
    return ticketsCred.reduce((
        prevValue: PinnedDashboard[],
        current
    ) => [...prevValue, ...current.dashboards], []).map((target) => {
        let path = `${URLAPP.tickets}/${target.id}`;
        let menuItem: NavItemDataProps = {
            id: counter++,
            label: target.title,
            description: target.description,
            avatar: `${process.env.REACT_APP_URL_PORTAL_API}${webApiEndpoints.tickets.iconoProyecto.url}/${target.idCredential}/${target.avatar}`,
            path,
            breadcrumbs: [...menu.breadcrumbs, { label: target.title, path }]
        }
        return menuItem
    });
}

const businessHelper = {
    reduceCredentialsToRepo: (list: CredentialType[], subtype: RepositoryApiSubTypes) => {
        let data = list.reduce(
            (prev: RepositoryType[], next) => [
                ...prev,
                ...next.repositories.filter(r => r.subtype === subtype)
            ],
            []
        )
        return data
    },
    groupApis: (data: SwaggerApiType[]) => {
        let mapData: Map<string, ApidocType[]> = new Map();
        data.sort((a, b) => a.name > b.name ? 1 : -1).forEach(api => {
            let url = api.properties.find(p => p.type === 'Swagger')?.url || ''
            let published = api.properties.find(p => p.type === 'X-Published')?.value || ''
            let urlParts = url.split(`/`)
            let apidocItem: ApidocType = {
                name: urlParts[5],
                tag: api.name,
                description: api.description,
                url
            }
            let [group] = apidocItem.name.split('-')
            if (published !== 'false') {
                mapData.get(group) ? mapData.get(group)?.push(apidocItem) : mapData.set(group, [apidocItem])
            }
        })
        return mapData
    },
    paginateData: (data: any[], withPaginator: PaginatorProps) => {
        let minIndex = withPaginator.page * withPaginator.perPage
        let maxIndex = (withPaginator.page + 1) * withPaginator.perPage
        maxIndex = maxIndex > data.length ? data.length : maxIndex
        return data.slice(minIndex, maxIndex)
    },
    hideCharacters,

    hideFirstCharacters,

    hideEmail,

    hidePersonalDataOnJson,

    generateUserMenu: (
        appMenu: NavItemDataProps[],
        mapApiRest: Map<string, ResourceType[]>,
        soap: ResourceType[],
        linkedResources: ResourceType[],
        ticketsCred: CredentialJiraType[]
    ) => {
        let apisMenuItems: NavItemDataProps[] = []
        let counter = 200
        appMenu.forEach(m => {
            let data: NavItemDataProps | null = { ...m }
            if (m.path?.startsWith(URLAPP.linkedResources) && (m.items?.length || 0) > 0) {
                let updatePath = `${URLAPP.linkedResourcesGroup}${m.path.replace(URLAPP.linkedResources, '')}`
                let idsMenuWithResources = linkedResources.reduce((previousValue: number[], currentValue) => [...previousValue, ...(currentValue.linkedMenus || [])], [])
                data = menuFilterLinkedResources(idsMenuWithResources, data)
                if (data) { data.path = updatePath }
            }
            if (m.path === URLAPP.tickets && data) {
                data.items = generateTicketsMenu(ticketsCred, m);
                data.displayRow = true;
                if (data.items.length === 0) {
                    data = null;
                }
            }
            if (m.path === URLAPP.apidoc && !m.items && mapApiRest && data) {
                let mapSoap: Map<string, NavItemDataProps[]> = new Map()
                soap.forEach(item => {
                    let group = item.name.split('-')[0].trim()
                    let path = `${URLAPP.apidocSoapDoc}/${item.name}`
                    let menuItem: NavItemDataProps = {
                        id: counter++,
                        label: item.label,
                        path,
                        breadcrumbs: [...m.breadcrumbs, { label: item.label, path }]
                    }
                    mapSoap.get(group) ? mapSoap.get(group)?.push(menuItem) : mapSoap.set(group, [menuItem])
                })
                data.items = Array.from(mapApiRest.keys())
                    .sort((a, b) => a > b ? 1 : -1)
                    .map(k => {
                        let groupPath = `${URLAPP.apidocGroup}/${k}`
                        let clasificationBreadCrumb = { label: k, path: groupPath }
                        let items: NavItemDataProps[] = mapApiRest.get(k)?.map(item => {
                            let path = `${URLAPP.apidocRestDoc}/${item.name}`
                            return {
                                id: counter++,
                                label: item.description,
                                description: item.versions[0].note,
                                path,
                                breadcrumbs: [...m.breadcrumbs, clasificationBreadCrumb, { label: item.description, path }]
                            }
                        }) || []
                        if (mapSoap.get(k)) {
                            items = [...items, ...(mapSoap.get(k) || [])]
                            mapSoap.delete(k)
                        }
                        return {
                            id: counter++,
                            label: k,
                            path: groupPath,
                            items,
                            breadcrumbs: [...(data?.breadcrumbs || []), clasificationBreadCrumb]
                        }
                    })
                mapSoap.forEach((mapValue, mapKey) => {
                    if (data) {
                        data.items = [...(data.items || []), {
                            id: counter++,
                            label: mapKey,
                            path: `${URLAPP.apidocGroup}/${mapKey}`,
                            items: mapValue,
                            breadcrumbs: [...m.breadcrumbs, { label: mapKey, path: `${URLAPP.apidocSoapDoc}/${mapKey}` }]
                        }]
                    }
                })
            }
            if (data) {
                apisMenuItems.push(data)
            }
        })
        return apisMenuItems
    },
    getUrlPaths,
    getMenuRolData: (idMenus: number[], rolesData: UserRolType[]) => {
        let rolesMenuData: MenusRolProps[] = []
        for (let idMenu of idMenus) {
            for (let rol of (rolesData || [])) {
                let target = mapper.menuListToArray(rol.menu, 0).find(m => m.id === idMenu)
                if (target) {
                    rolesMenuData.push({
                        id: idMenu,
                        idRol: rol.id,
                        label: target?.label,
                        path: target?.path || '',
                        rol: rol.name
                    })
                }
            }
        }
        return rolesMenuData
    },
    searchPagePath: (path: string) => {
        let paths: string[] = []
        for (let p in URLAPP) {
            paths.push(URLAPP[p as keyof typeof URLAPP])
        }
        return paths.includes(path)
    },
    createPageIndex: (pageData: HTMLElement | null) => {
        let link = (header: PageHeaderProps) => '<li><a href="#' + header.id + '">' + header.title + '</a></li>'
        let html = '<ul>'
        let headers: PageHeaderProps[] = [];
        pageData?.childNodes && iterateThroughNodes(Array.from(pageData.childNodes), headers)
        headers.forEach((header, index) => {
            let prev = headers[index - 1] || null
            if (!index || prev?.level === header.level) {
                html += link(header)
            }
            else if (prev?.level > header.level) {
                html += '</ul>' + link(header)
            }
            else if (prev?.level < header.level) {
                html += '<ul>' + link(header)
            }
        })
        html += '</ul>'
        return html
    },
    formatImages: (content: string) => {
        let data = document.createElement('body');
        data.innerHTML = content;
        data?.querySelectorAll('img').forEach((el) => {
            let src = `${el.src.split('?')[0]}?attachmentId=${el.getAttribute('data-linked-resource-id')}`;
            console.log(src)
            el.src = src;
            el.classList.add("img-placeholder");
            el.setAttribute('data-image-src', src);
            el.setAttribute('srcset', src);
        });
        return data.innerHTML;
    },
    handleFormArtifactSubmit: (formArtifacts: ArtifactFormProp[]) => {
        let files: File[] = []
        let artifacts: ResourceVersionArtifactType[] = [];
        formArtifacts.forEach((element, index) => {
            if (element.item?.[0]) {
                artifacts.push({
                    id: index,
                    name: element.item?.[0].name || '',
                    type: element.type || 'DOC'
                })
                files.push(element.item?.[0]);
            } else {
                artifacts.push({
                    id: index,
                    name: element.type || '',
                    path: element.documentationReference || '',
                    type: element.type || ''
                })
            }
        })
        return { artifacts, files }
    },
    sortVersion: (items: ResourceVersionType[]) => {
        return [...items].sort((a, b) => {
            let aVersion = getVersionSplit(a.version)
            let bVersion = getVersionSplit(b.version)
            for (let i = 0; i < aVersion.length; i++) {
                if (bVersion.length <= i || aVersion[i] > bVersion[i]) {
                    return -1;
                } else if (aVersion[i] < bVersion[i]) {
                    return 1;
                }
            }
            if (bVersion.length > aVersion.length) {
                return 1;
            }
            return 0
        })
    },
    sortVersions: (a: string, b: string) => {
        const getVersionSplit = (version: string): number[] => {
            if (regexp_version.test(version)) {
                return version.split('.').map(v => Number(v))
            }
            return []
        }
        let aVersion = getVersionSplit(a)
        let bVersion = getVersionSplit(b)
        for (let i = 0; i < aVersion.length; i++) {
            if (bVersion.length <= i || aVersion[i] > bVersion[i]) {
                return -1;
            } else if (aVersion[i] < bVersion[i]) {
                return 1;
            }
        }
        if (bVersion.length > aVersion.length) {
            return 1;
        }
        return 0
    }
}

function getVersionSplit(version: string): number[] {
    if (regexp_version.test(version)) {
        return version.split('.').map(v => Number(v))
    }
    return []
}

function menuFilterLinkedResources(idsMenuWithResources: number[], element: NavItemDataProps): NavItemDataProps | null {
    element.items = element.items?.filter(i => idsMenuWithResources.includes(i.id) || menuFilterLinkedResources(idsMenuWithResources, i) !== null)
    return (element.items?.length || 0) > 0 ? element : null;
}

function getUrlPaths(menu: NavItemDataProps[]) {
    let paths: string[] = []
    menu.forEach(m => {
        paths.push(m.path || '')
        if (m.items) {
            paths = [...paths, ...getUrlPaths(m.items)]
        }
    })
    return paths
}

function iterateThroughNodes(nodes: ChildNode[], headers: PageHeaderProps[]) {
    nodes.forEach((node) => {
        var sub = Array.from(node.childNodes)
        if (sub.length) {
            iterateThroughNodes(sub, headers)
        }
        let htmlNode = node as HTMLElement
        if (/h[1-4]/i.test(htmlNode.tagName)) {
            headers.push({
                id: htmlNode.getAttribute('id') || '',
                level: parseInt(htmlNode.tagName.replace('H', '')),
                title: htmlNode.innerText
            })
        }
    })
}


function hidePersonalDataOnJson(text: string) {
    let secureText = text
    const checkRules = [
        { regex: /\d{10}/g, rule: hideCharacters },
        { regex: /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, rule: hideEmail }
    ]
    for (let item of checkRules) {
        (text.match(item.regex) || []).map(match => ({
            original: match,
            updated: item.rule(match)
        })).forEach(matches => {
            secureText = secureText.replaceAll(`${matches.original}"`, `${matches.updated}"`)
        })
    }
    return secureText
}

export default businessHelper